var _isIOS = function () {
    return navigator && navigator.userAgent && /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
};
var scheme = 'local';
var _bridgeurl = function (action, parameters, id) {
    if (!action) {
        return;
    }
    var link = scheme + "://" + action;
    if (parameters) {
        var kvs = [];
        for (let key in parameters) {
            try {
                var encodedkey = encodeURIComponent(key);
                var value = parameters[key];
                var encodedValue;
                if (typeof (value) == "object") {
                    encodedValue = encodeURIComponent(JSON.stringify(value));
                } else {
                    encodedValue = encodeURIComponent(value);
                }
                kvs.push(encodedkey + "=" + encodeURIComponent(encodedValue));
                /* eslint no-empty: 0 */
            } catch (e) {
            }
        }
        link += ("?" + kvs.join("&"));
        if (id) {
            link += ("&callback=" + id);
        }
    } else {
        if (id) {
            link += ("?callback=" + id);
        }
    }
    return link;
};

var bridge = function () {
    var callbacks = [],
        callbackID = 0;
    document.addEventListener("PacificDidReceiveLocalCallback",
        function (e) {
            if (e.detail) {
                var detail = e.detail;
                var id = isNaN(parseInt(detail.id)) ? -1 : parseInt(detail.id);
                if (id != -1) {
                    callbacks[id] && callbacks[id](detail.parameters, detail.error);
                    delete callbacks[id];
                }
            }
        },
        false);
    return {
        "post": function (action, parameters, callback) {
            var id = callbackID++;
            callbacks[id] = callback;
            if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.pacific) {
                window.webkit.messageHandlers.pacific.postMessage({
                    "action": action,
                    "parameters": parameters,
                    "callback": id
                });
            } else {
                var src = _bridgeurl(action, parameters, id);
                if (src) {
                    var bridge = document.createElement("iframe");
                    bridge.setAttribute("style", "display:none");
                    bridge.setAttribute("height", "0px");
                    bridge.setAttribute("width", "0px");
                    bridge.setAttribute("frameloader", "0");
                    bridge.src = src;
                    document.body.appendChild(bridge);
                    document.body.removeChild(bridge);
                }
            }
        },
        openUrl: function (url) {
            if (_isIOS()) {
                bridge.post('open_url', { 'url': url });
            } else {
                if (typeof androidObj != 'undefined') {
                    androidObj.call(url);
                } else {
                    alert("no androidobject");
                }
            }
        },
        postClientMessage: function (action) {
            if (_isIOS()) {
                bridge.post(action);
            } else {
                if (typeof androidObj != 'undefined') {
                    androidObj.call("local://" + action);
                } else {
                    alert("no androidobject");
                }
            }
        }
    };
}();
export {
    bridge
};